module.exports = "images/d0d44cae5cd730143b195ebff7ef1f20.png";